module.exports = __webpack_public_path__ + "media/images/emblems/Mammern-Blazono-d2787487279970c7f9ea4dc3f8e820f6.png";